<template>
  <v-dialog v-model="newUserDialog" max-width="1200px" persistent>
    <v-card style="border-radius: 10px">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Detail</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>
      <v-layout row wrap style="padding: 35px" justify-center>
        <v-flex xs12 sm4>
          <div style="text-align: center"><h2>weserve</h2></div>
          <div style="display: flex; justify-content: center">
            <img src="@/assets/bank-svg.svg" />
          </div>
          <div style="padding: 5px">
            <div class="text">Bank name</div>
            <div style="display: flex">
              <img
                :src="getDetailCash.bank_weserve.bank_weserve_bank.bank_icon"
                style="width:30px; height: 27px;"
              />
              <h3 style="padding: 2px">
                {{ getDetailCash.bank_weserve.bank_weserve_bank.bank_name_en }}
              </h3>
            </div>
          </div>
          <div style="padding: 5px">
            <div class="text">Bank number</div>
            <h3>
              {{ getDetailCash.bank_weserve.bank_weserve_account_number }}
            </h3>
          </div>
          <div style="padding: 5px">
            <div class="text">Account name</div>
            <h3>{{ getDetailCash.bank_weserve.bank_weserve_account_name }}</h3>
          </div>
        </v-flex>
        <v-flex xs12 sm4>
          <div
            style="display: flex; justify-content: center; margin-top: 30px;"
          >
            <img
              src="@/assets/Group 5918.svg"
              v-if="$vuetify.breakpoint.xs"
              style="height: 30px;transform: rotate(0.25turn);"
            />
            <img src="@/assets/Group 5918.svg" v-else />
          </div>
          <div
            style="
                    display: flex;
                    margin-top: 15px;
                    justify-content: center;
                    margin-top: 10px;
                  "
          >
            <h3 style="margin-right:10px">Status:</h3>
            <h3
              :style="{
                color:
                  getDetailCash.status == 1
                    ? '#fbd200'
                    : getDetailCash.status == 2
                    ? ' #4caf50'
                    : getDetailCash.status == 3
                    ? ' #f44336'
                    : getDetailCash.status == 4
                    ? '#f44336'
                    : null,
              }"
            >
              {{
                getDetailCash.status == 1
                  ? "PADDING"
                  : getDetailCash.status == 2
                  ? "APPROVE"
                  : getDetailCash.status == 3
                  ? "REJECT"
                  : getDetailCash.status == 4
                  ? "DELETE"
                  : null
              }}
            </h3>
          </div>
          <div style="padding: 50px;">
            <v-text-field
              disabled
              v-if="getDetailCash.status == 3"
              type="text"
              :placeholder="getDetailCash.remark"
              outline
            ></v-text-field>
          </div>
        </v-flex>
        <v-flex
          xs12
          sm4
          :style="{
            marginTop: this.$vuetify.breakpoint.xs ? '50px' : null,
          }"
        >
          <div style="text-align: center"><h2>weserve</h2></div>
          <div style="display: flex; justify-content: center">
            <img src="@/assets/XMLID_830.svg" />
          </div>
          <div style="padding: 5px">
            <div class="text">Bank name</div>
            <div style="display: flex">
              <img
                :src="getDetailCash.bank_manager.bank_manager_bank.bank_icon"
                style="width:30px; height: 27px;"
              />
              <h3 style="padding: 2px">
                {{ getDetailCash.bank_manager.bank_manager_bank.bank_name_en }}
              </h3>
            </div>
          </div>
          <div style="padding: 5px">
            <div class="text">Bank number</div>
            <h3>
              {{ getDetailCash.bank_manager.bank_manager_bank_number }}
            </h3>
          </div>
          <div style="padding: 5px">
            <div class="text">Account name</div>
            <h3>{{ getDetailCash.bank_manager.bank_manager_customer_name }}</h3>
          </div>
        </v-flex>
      </v-layout>
      <v-divider class="mx-4"></v-divider>
      <v-layout justify="space-between" style="padding:35px">
        <v-flex xs12 sm6>
          <div style="display: flex; justify-content: start">
            <div>
              <h3>Withdraw</h3>
              <h3 style="color: red">Commission</h3>
              <h3 style="color: green">Total</h3>
            </div>
          </div>
        </v-flex>
        <v-flex xs12 sm6>
          <div style="display: flex; justify-content: end">
            <div>
              <h3>{{ `${getDetailCash.withdraw_price} THB` }}</h3>
              <h3 style="color: red">
                {{ `${getDetailCash.commission_price} THB` }}
              </h3>
              <h3 style="color: green">
                {{ `${getDetailCash.total_price} THB` }}
              </h3>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog"],
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapState({
      getDetailCash: (state) => state.cashRequest.getDetailCash,
    }),
  },
};
</script>
